import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axiosInstance from "../utils/axiosInstance";

function ChangePassword() {
  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      newPassword: Yup.string()
        .required("New password is required")
        .min(8, "Password must be at least 8 characters"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords must match")
        .required("Please confirm your password"),
    }),
    onSubmit: async (values) => {
      try {
        await axiosInstance.post("/auth/change-password", {
          password: values.newPassword,
        });

        alert("Password changed successfully!");
        // Redirect to login or dashboard
        window.location.href = "/login";
      } catch (error) {
        console.log(error);
        alert(error.response?.data?.message || "Failed to change password");
      }
    },
  });

  return (
    <div className="flex justify-center items-center min-h-screen p-4">
      <form
        onSubmit={formik.handleSubmit}
        className="w-full max-w-md bg-white p-6 rounded shadow-md space-y-4"
      >
        <h2 className="text-2xl mb-4 font-bold">Change Password</h2>
        <div>
          <label className="block text-gray-700">New Password</label>
          <input
            type="password"
            name="newPassword"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full px-3 py-2 border rounded"
          />
          {formik.touched.newPassword && formik.errors.newPassword ? (
            <div className="text-red-500">{formik.errors.newPassword}</div>
          ) : null}
        </div>
        <div>
          <label className="block text-gray-700">Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full px-3 py-2 border rounded"
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
            <div className="text-red-500">{formik.errors.confirmPassword}</div>
          ) : null}
        </div>
        <button
          type="submit"
          className="w-full px-3 py-2 bg-blue-500 text-white rounded"
        >
          Change Password
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
